import { Svg, SvgPath, SvgProps } from '../../../components/svg';

export function PlaygroundSlide(props: SvgProps) {
  return (
    <Svg {...props} viewBox="0 0 20 20">
      <SvgPath d="M14.025 12.875C13.725 12.4167 13.4834 11.9917 13.2584 11.6C12.2834 9.925 11.4917 8.79167 9.16671 8.44167V4.58334C9.16671 2.97501 7.85837 1.66667 6.25004 1.66667C4.64171 1.66667 3.33337 2.97501 3.33337 4.58334V18.3333H5.00004V16.6667H7.50004V18.3333H9.16671V10.1333C10.6334 10.4167 11.075 11.1583 11.8084 12.4333C12.05 12.8583 12.3167 13.3083 12.6417 13.8C14.5084 16.6 16.3917 18.3333 20 18.3333V16.6667C17.1084 16.6667 15.6667 15.3333 14.025 12.875ZM6.25004 3.33334C6.94171 3.33334 7.50004 3.89167 7.50004 4.58334V8.33334H5.00004V4.58334C5.00004 3.89167 5.55837 3.33334 6.25004 3.33334ZM5.00004 15V13.3333H7.50004V15H5.00004ZM7.50004 11.6667H5.00004V10H7.50004V11.6667Z" />
    </Svg>
  );
}
